import { useAppSelector } from '@/store/hooks/redux';
import { selectPlaces } from '@/editor/store/reducers/adSet-step.slice';
import { useEffect } from 'react';
import { mapService } from '@/editor/components/googleMaps/google-map-service';

export const useRestoreCircles = (initialized: boolean, mapLoaded: boolean) => {
  const places = useAppSelector(selectPlaces);

  useEffect(() => {
    if (places.length === 0) return;
    if (initialized) return;
    if (!mapLoaded) return;

    mapService.addCirclesToMap(places);
  }, [places, initialized, mapLoaded]);
};
